module.exports = __webpack_public_path__ + "static/media/tiktokIcon.3a2f9ec2.svg";